import Icon from 'veui/components/Icon'

Icon.register({
  'flow-go-on': {
    paths: [
      {
        d: 'M553.37 374.63a32 32 0 0045.26 0l128-128a32 32 0 000-45.26l-128-128a32 32 0 00-45.26 45.26L626.76 192H256a224 224 0 000 448h320a32 32 0 000-64H256c-88.22 0-160-71.78-160-160s71.78-160 160-160h370.76l-73.39 73.37a32 32 0 000 45.26z'
      }
    ],
    width: '768',
    height: '768'
  }
})
